import { render, staticRenderFns } from "./OrdersExport.vue?vue&type=template&id=41926563&scoped=true"
import script from "./OrdersExport.vue?vue&type=script&lang=js"
export * from "./OrdersExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41926563",
  null
  
)

export default component.exports